module.exports = __webpack_public_path__ + "static/media/belt-red.5534fe8c.png";